/*** IMPORTS FROM imports-loader ***/
var define = false;

export function mobileNav() {
  var hamburger = document.querySelector('.hamburger');
  var body = document.querySelector('body');

  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('is-active');
    if (body.classList.contains('navOpen')) {
      body.classList.remove('navOpen');
    } else {
      body.classList.add('navOpen');
    }
  });

  $('.mainNav__listLink--hasChildren').on('click tap', function(e) {
    e.preventDefault();
    $(this).parent().find('.mainNav__subListContainer').addClass('open');
  });

  $('.mainNav__back').on('click tap', function() {
    $('.mainNav__subListContainer').removeClass('open');
  });

  // $('.mainNav__subListSection').hide();

  // $('.mainNav__subListColTitle').on('click tap', function(e) {
  //   e.preventDefault();
  //   $(this).toggleClass('open');
  //   $(this).parent().parent().find('.mainNav__subListSection').slideToggle();
  // });
}
